import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["searchable", "searchablePlaceholder", "attribute", "operator", "limit", "showMore", "showMoreLimit", "sortBy", "escapeFacetValues", "transformItems", "translations"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useRef, useState } from 'react';
import { useRefinementList } from 'react-instantsearch-hooks';
import { RefinementList as RefinementListUiComponent } from "../ui/RefinementList.js";
import { SearchBox as SearchBoxUiComponent } from "../ui/SearchBox.js";
export function RefinementList(_ref) {
  var searchable = _ref.searchable,
      searchablePlaceholder = _ref.searchablePlaceholder,
      attribute = _ref.attribute,
      operator = _ref.operator,
      limit = _ref.limit,
      showMore = _ref.showMore,
      showMoreLimit = _ref.showMoreLimit,
      sortBy = _ref.sortBy,
      escapeFacetValues = _ref.escapeFacetValues,
      transformItems = _ref.transformItems,
      translations = _ref.translations,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useRefinementList = useRefinementList({
    attribute: attribute,
    operator: operator,
    limit: limit,
    showMore: showMore,
    showMoreLimit: showMoreLimit,
    sortBy: sortBy,
    escapeFacetValues: escapeFacetValues,
    transformItems: transformItems
  }, {
    $$widgetType: 'ais.refinementList'
  }),
      canRefine = _useRefinementList.canRefine,
      canToggleShowMore = _useRefinementList.canToggleShowMore,
      isFromSearch = _useRefinementList.isFromSearch,
      isShowingMore = _useRefinementList.isShowingMore,
      items = _useRefinementList.items,
      refine = _useRefinementList.refine,
      searchForItems = _useRefinementList.searchForItems,
      toggleShowMore = _useRefinementList.toggleShowMore;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var inputRef = useRef(null);

  function setQuery(newQuery) {
    setInputValue(newQuery);
    searchForItems(newQuery);
  }

  function onRefine(item) {
    refine(item.value);
    setQuery('');
  }

  function onChange(event) {
    setQuery(event.currentTarget.value);
  }

  function onReset() {
    setQuery('');
  }

  function onSubmit() {
    if (items.length > 0) {
      refine(items[0].value);
      setQuery('');
    }
  }

  var mergedTranslations = _objectSpread({
    resetButtonTitle: 'Clear the search query',
    submitButtonTitle: 'Submit the search query',
    noResultsText: 'No results.',
    showMoreButtonText: function showMoreButtonText(options) {
      return options.isShowingMore ? 'Show less' : 'Show more';
    }
  }, translations);

  var uiProps = {
    items: items,
    canRefine: canRefine,
    onRefine: onRefine,
    query: inputValue,
    searchBox: searchable && /*#__PURE__*/React.createElement(SearchBoxUiComponent, {
      inputRef: inputRef,
      placeholder: searchablePlaceholder,
      isSearchStalled: false,
      value: inputValue,
      onChange: onChange,
      onReset: onReset,
      onSubmit: onSubmit,
      translations: {
        submitButtonTitle: mergedTranslations.submitButtonTitle,
        resetButtonTitle: mergedTranslations.resetButtonTitle
      }
    }),
    noResults: searchable && isFromSearch && items.length === 0 && mergedTranslations.noResultsText,
    canToggleShowMore: canToggleShowMore,
    onToggleShowMore: toggleShowMore,
    isShowingMore: isShowingMore,
    translations: {
      showMoreButtonText: mergedTranslations.showMoreButtonText
    }
  };
  return /*#__PURE__*/React.createElement(RefinementListUiComponent, _extends({}, props, uiProps, {
    showMore: showMore
  }));
}